/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfirmOrderCommand } from '../../models/confirm-order-command';
import { ConfirmOrderCommandResult } from '../../models/confirm-order-command-result';

export interface ApiNurseryManagerOrdersConfirmOrderPost$Params {
      body?: ConfirmOrderCommand
}

export function apiNurseryManagerOrdersConfirmOrderPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersConfirmOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfirmOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersConfirmOrderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConfirmOrderCommandResult>;
    })
  );
}

apiNurseryManagerOrdersConfirmOrderPost.PATH = '/api/NurseryManager/Orders/ConfirmOrder';
